import axiosInstance from '../config/axios.js';
import { clearCompanyLogoCache } from '../hooks/useCompanyLogo.js';
import { clearDashboardCache } from './dashboardCache.js';
import { readAuthUser, writeAuthUser } from './authSession.js';

const KEY = 'essaar_switch_boot';

export function readAgentEnvironmentBoot() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    return null;
  }
}

export function clearAgentEnvironmentBoot() {
  sessionStorage.removeItem(KEY);
}

export function beginAgentSwitch(name, phase) {
  const detail = { name, phase, pending: true };
  sessionStorage.setItem(KEY, JSON.stringify({ name, phase }));
  window.dispatchEvent(new CustomEvent('essaar-agent-switch', { detail }));
}

export function cancelAgentSwitch() {
  clearAgentEnvironmentBoot();
  window.dispatchEvent(new CustomEvent('essaar-agent-switch-clear'));
}

export function agentSwitchLoaderText(boot) {
  if (!boot) return '';
  if (boot.phase === 'own') return 'Switching to your account';
  if (boot.phase === 'open') return `Opening the ${boot.name} environment`;
  return `Switching to the ${boot.name} environment`;
}

export function agentSwitchReadyText(boot) {
  if (!boot || boot.phase === 'own') {
    return 'Application is ready. You are on your own account. You can update the data now.';
  }
  return `Application is ready. You are working as ${boot.name}. You can update the data now.`;
}

export async function saveAgentSwitch(targetUserId, displayName, phase) {
  beginAgentSwitch(displayName, phase);
  try {
    const response = await axiosInstance.post('/auth/agent-switch', {
      target_user_id: targetUserId,
    });
    const current = readAuthUser() || {};
    const next = {
      ...current,
      ...(response.data?.data || {}),
      token: current.token,
      token_expiry: current.token_expiry,
    };
    writeAuthUser(next);
    clearDashboardCache();
    clearCompanyLogoCache();
    window.location.assign('/agent-dashboard');
  } catch (err) {
    cancelAgentSwitch();
    throw err;
  }
}
